import React from 'react';
import { useNavigate } from 'react-router-dom';

const MoreHelpPage = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto p-6">
            <div className="bg-gray-100 rounded-lg shadow-md text-center p-10 mx-6">
                <div className="flex flex-col items-center justify-center mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-10 h-10 inline-block align-middle mr-2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                    </svg>
                    <h2 className="text-black-600 text-2xl font-bold mb-5 mt-4">Thank You for Your Response!</h2>
                </div>
                <div> 
                    <h2 className="text-black-600 text-xl font-semibold mb-5 mt-4">Our team will reach you shortly!</h2>
                </div>
                <button
                    className="inline-block px-4 py-2 bg-black text-white rounded-md text-center font-semibold text-lg hover:bg-blue-600 transition duration-300"
                    onClick={() => navigate('/')}
                >
                    Go to Home Page
                </button>
            </div>
        </div>
    );
}

export default MoreHelpPage;